import { whatIsMyNextPixkupDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getwhatIsMyNextPixkupEn = () => {
  const data = whatIsMyNextPixkupDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addwhatIsMyNextPixkup = () => {
  if (
    window.location.href.includes(
      `us/en/support/faqs/when-is-my-next-pickup`,
    ) &&
    document.getElementById(`whatIsMyNextPixkupJSONLD`) === null
  ) {
    const script = whatIsMyNextPixkupJSONLDEn()
    addJSONLDToHead(script, `whatIsMyNextPixkupJSONLD`)
  } else {
    removeElement(`whatIsMyNextPixkupJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const whatIsMyNextPixkupJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getwhatIsMyNextPixkupEn(),
  }
  return FaqBagsterTemplate
}
